import React, { useEffect, useRef } from "react";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, FormGroup } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { HugeiconsIcon } from "@hugeicons/react";
import { FloppyDiskIcon } from "@hugeicons/core-free-icons";
import { AntInput } from "../../CommonElements/AntInput";
import { message, Space } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useResetPasswordMutation } from "../../services/useAuth/useAuthMutation";

export const ResetPassword = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      token: "",
      password: "",
      password_confirmation: "",
    },
  });
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutate: resetPasswordMutation, isPending } =
    useResetPasswordMutation(setError);
  const tokenRef = useRef(null);
  const [messageApi, contextHolder] = message.useMessage();

  const onSubmit = (data) => {
    resetPasswordMutation(data, {
      onSuccess: () => {
        messageApi.open({
          type: "success",
          content: t("PASSWORD_RESET_SUCCESSFULLY"),
          duration: 5,
        });
      },
    });
  };

  useEffect(() => {
    // Extract token from URL query parameter
    const token = searchParams.get("token");

    if (token) {
      setValue("token", token);
      tokenRef.current = token;

      // Remove token from URL
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("token");
      setSearchParams(newSearchParams, { replace: true });
    }

    if (!tokenRef.current) {
      navigate("/login");
    }
  }, [searchParams, setValue, setSearchParams]);

  return (
    <div className="login-card1 decorative-arabic-text-bg h-100">
      {contextHolder}
      <Form
        className="theme-form login-form pattern-card rounded-3 border border-1"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Stack gap={3}>
          <h4>{t("RESET_PASSWORD")}</h4>
          <h6>{t("RESET_PASSWORD_DESCRIPTION")}</h6>
        </Stack>

        <FormGroup>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <>
                <AntInput
                  type="password"
                  placeholder={t("PASSWORD")}
                  {...field}
                />

                {errors.password && (
                  <div className="text-danger small mt-1">
                    {errors.password.message}
                  </div>
                )}
              </>
            )}
          />
        </FormGroup>
        <FormGroup>
          <Controller
            name="password_confirmation"
            control={control}
            render={({ field }) => (
              <>
                <AntInput
                  type="password"
                  placeholder={t("CONFIRM_PASSWORD")}
                  {...field}
                />

                {errors.password && (
                  <div className="text-danger small mt-1">
                    {errors.password.message}
                  </div>
                )}
              </>
            )}
          />
        </FormGroup>
        <FormGroup>
          <button
            disabled={isPending}
            type="submit"
            className="btn btn-primary m-0 w-100"
          >
            <Space align="center">
              <HugeiconsIcon className="d-flex" icon={FloppyDiskIcon} />
              {isPending ? t("SAVING") : t("SAVE")}
            </Space>
          </button>
        </FormGroup>
      </Form>
    </div>
  );
};
